<template>
    <div class="trailer-player-container">
        <youtube-player 
            :video-id="youtubeVideoId"
            @ended="ended"
            @error="error"
        />
    </div>
</template>

<script setup lang="ts">
    import { useRoute, useRouter } from 'vue-router'
    import { computed, onMounted, onBeforeUnmount, type ComputedRef } from 'vue';
    import YoutubePlayer from "@/components/widgets/YoutubePlayer/YoutubePlayer.vue";
    import { type YoutubeSettings } from "@/components/widgets/YoutubePlayer/types";
    import { useApplicationStore } from "@/stores/Application";
    import {Strings} from "@/locales/types/enums/strings";
    import { useI18n } from "vue-i18n";

    definePageMeta({ layout: 'default-no-header' });

    const ApplicationStore = useApplicationStore();
    const { 
        setTooltipeShowing, 
        setTooltipeMessage,
    } = ApplicationStore;

    const { t } = useI18n();
    const { $navigator} = useNuxtApp();
    const route = useRoute();
    const router = useRouter();
    const settings: ComputedRef<YoutubeSettings> = computed(() => route.query as YoutubeSettings);
    const youtubeVideoId: string = settings.value.youtubeVideoId;

    const ended = () => {
        goToBack();
    };
    const error = (event: YT.OnErrorEvent) => {
        goToBack();

        setTooltipeMessage(t(Strings.YOUTUBE_ERROR_DEFAULT).toString());
        setTooltipeShowing({visible: true, showingTime: 5000});
        console.error('Youtube error:', event);
    };
    const registerKeyListeners = () => {
        $navigator.on("keypress:back", goToBack);
    };
    const unregisterKeyListeners = () => {
        $navigator.off("keypress:back", goToBack);
    };
    const goToBack = () => {
        router.go(-1);
    };

    onMounted(() => {
        registerKeyListeners();
    });

    onBeforeUnmount(() => {
        unregisterKeyListeners();
    });
</script>

<style lang="scss">
    @import url("styles.scss");
</style>